// Dashboard.jsx
import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";

import { ReactComponent as DashboardIcon } from './assets/icons/dashboard.svg';
import { ReactComponent as UsersIcon } from './assets/icons/users.svg';
import { ReactComponent as PaymentsIcon } from './assets/icons/payments.svg';
import { ReactComponent as CountriesIcon } from './assets/icons/countries.svg';
import { ReactComponent as InviterIcon } from './assets/icons/inviter.svg';

import { DashboardPage } from "./pages/DashboardPage.tsx";
import SourcesChart from "./components/SourcesChart.tsx";
import UsersTable from "./components/UsersTable.tsx";
import { PaymentsPage } from "./pages/PaymentsPage.tsx";
import { CountriesPage } from "./pages/CountriesPage.tsx";
import axiosInstance from "./axiosInstance.tsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InvitersPage } from "./pages/InvitersPage.tsx";
import { TbArrowBackUp } from "react-icons/tb";
import { Logo } from "./components/Logo.tsx";



export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);

  return isMobile;
}





// --- Анимации ---
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(20px); }
`;

const AnimatedContent = styled.div<{ state: "entering" | "exiting" | "idle" }>`
  animation: ${({ state }) =>
      state === "entering" ? fadeIn : state === "exiting" ? fadeOut : "none"}
    0.3s forwards;
`;

// --- Здесь твои стили без изменений ---
const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: rgba(0, 0, 0, 1);
  font-family: 'Onest', sans-serif;
`;

const Sidebar = styled.div`
  width: 260px;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 40px;
  border-right: 1px solid var(--outline-color);
`;

const Icon = styled.svg<{ active?: boolean }>`
  width: 20px;
  height: 20px;
  color: ${({ active }) => (active ? 'var(--text-active-color)' : 'var(--text-secondary-color)')};
  path, circle, rect, line, polygon {
    stroke: currentColor !important;
  }
`;

const SidebarItem = styled.div<{ active?: boolean }>`
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Onest', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: ${({ active }) => (active ? "var(--text-active-color)" : "var(--text-secondary-color)")};
  cursor: pointer;
  background-color: ${({ active }) => (active ? "rgba(22, 22, 23, 1)" : "transparent")};
`;

const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

      @media (max-width: 768px) {
    gap: 10px;

  padding-top: calc(
    env(safe-area-inset-top, var(--tg-content-safe-area-inset-top)) 
    + var(--tg-content-safe-area-inset-top)
  );
  padding-bottom: env(safe-area-inset-bottom, var(--tg-content-safe-area-inset-bottom));
  padding-left: env(safe-area-inset-left, var(--tg-content-safe-area-inset-left));
  padding-right: env(safe-area-inset-right, var(--tg-content-safe-area-inset-right));
    margin: 0; 
  }
`;

const Header = styled.div`
  height: 10%;
  justify-content: space-between;
  border-bottom: 1px solid var(--outline-color);
  color: white;
  padding: 25px 40px;
      @media (max-width: 768px) {
 
    padding-left: 8px;
    font-size: 18px;
    line-height: 30px;
    box-shadow: 0;
    padding-right: 8px;
    height: auto;
  }
  font-family: 'Onest', sans-serif;
  font-weight: 500;
  font-size: 28px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
    -webkit-overflow-scrolling: touch; /* плавный скролл на iOS */
  overflow-y: auto;
      @media (max-width: 768px) {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 0;
    
    padding-bottom: 0;
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
`;

const SidebarAvatar = styled.div`
  border-radius: 100%;
  background-image: url("/avatar.png");
  width: 40px;
  height: 40px;
  background-size: cover;
  background-position: center;
`;

const SidebarNav = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

const BotToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: rgba(14, 14, 16, 1);
  padding: 16px;
  border-radius: 16px;
  font-family: 'Onest', sans-serif;
  font-weight: 500;
  line-height: 30px;
  font-size: 20px;
  color: var(--text-color);
`;

const BackIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  &:hover {
    opacity: 0.7;
    transition: 0.2s;
  }
`;


const MobileNav = styled.div`

  position: fixed;
  bottom: env(safe-area-inset-bottom);
  width: 100%;
  height: 54px;
  backdrop-filter: blur(16px);
  background: rgba(0, 0, 0, 0.08);
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  border-radius: 47px;
  justify-content: space-around;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileNavItem = styled.div<{active?: boolean}>`
  display: flex;
  padding: 4px 16px 4px 16px;
  font-weight: 600;
  font-size: 12px;
  justify-content: space-around;
  width: 100%;
  border-radius: 53px;
  flex-direction: column;
  align-items: center;
  ${({ active }) => (active ? "background-color: rgba(255, 255, 255, 0.1);" : "")};
  color: ${({ active }) => (active ? "var(--text-active-color)" : "rgba(124, 128, 134, 1)")};
  font-size: 12px;
  gap: 4px;
  cursor: pointer;
`;

const MobileIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`;





const PullToRefreshWrapper = ({ isMobile, onRefresh, children }) => {
  const [pullStartY, setPullStartY] = useState<number | null>(null);
  const [pullDistance, setPullDistance] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleTouchStart = (e: React.TouchEvent) => {
    if (!contentRef.current) return;
    if (contentRef.current.scrollTop === 0) {
      setPullStartY(e.touches[0].clientY);
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (pullStartY !== null) {
      const distance = Math.max(e.touches[0].clientY - pullStartY, 50);
      if (distance > 0) {
        setPullDistance(distance);
      }
    }
  };

  const handleTouchEnd = () => {
    if (pullDistance > 40) { // порог для обновления
      onRefresh?.();
    }
    setPullDistance(0);
    setPullStartY(null);
  };

  if (!isMobile) return <>{children}</>;

  return (
    <Content
      ref={contentRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ transform: `translateY(${pullDistance / 2}px)`, transition: pullDistance === 0 ? "transform 0.2s ease-out" : "none" }}
    >
      {children}
    </Content>
  );
};




// --- Компонент ---
const Dashboard = () => {
  const savedTab = localStorage.getItem("activeTab") || "dashboard";
  const [activeTab, setActiveTab] = useState(savedTab);
  const [isPlaying, setIsPlaying] = useState(true);


  const [onBack, setOnBack] = useState(null);
  const [afterHeader, setAfterHeader] = useState(null)

  const [contentState, setContentState] = useState<"entering" | "exiting" | "idle">("entering");
  const tabNames = {dashboard: "Главная", users: "Пользователи", payments: "Выплаты", countries: "Страны", inviter: "Инвайтер"}
  const tabIcons: any = { users: UsersIcon, countries: CountriesIcon, dashboard: DashboardIcon, inviter: InviterIcon, payments: PaymentsIcon };

  const [data, setData] = useState({});

  const [userData, setUserData] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [countriesData, setCountriesData] = useState([]);
  const [countriesLoading, setCountriesLoading] = useState(false);

  const [inviters, setInviters] = useState([]);

    const isMobile = useIsMobile();

useEffect(() => {
  let isMounted = true;

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/inviters");
      const now = new Date().toISOString();
      const withTime = response.data.map(inv => ({
        ...inv,
        fetchTime: now
      }));

      if (isMounted) {
        console.log("update inviters");
        setInviters(withTime);
      } else {
        console.log("not update inviters");
      }
    } catch (error) {
      console.error("Ошибка при загрузке инвайтеров", error);
    }

    // После завершения запроса, через 5 секунд вызываем снова
    if (isMounted) {
      setTimeout(fetchData, 100);
    }
  };

  // Первый вызов
  fetchData();

  return () => {
    isMounted = false;
  };
}, []);




  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("day");
    useEffect(() => {
      setUserLoading(true);
      // имитация загрузки данных
      axiosInstance.get(`/users?period=${period}`).then((response) => {
        setUserData(response.data["users"]);
            setUserLoading(false);
      })},
  
     [period]);
  useEffect(() => {
    setLoading(true);
    axiosInstance.get(`/dashboard-metrics?period=${period}`).then(response => {
      setData(response.data);
      setLoading(false);
    });
  }, [period]);

    useEffect(() => {
    let isMounted = true;
    setCountriesLoading(true);
    axiosInstance.get('/countries')
      .then(response => {
        if (isMounted) setCountriesData(response.data);
      })
      .finally(() => {
        if (isMounted) setCountriesLoading(false);
      });
    return () => { isMounted = false; };
  }, []);
  

  useEffect(() => { localStorage.setItem("activeTab", activeTab); }, [activeTab]);
  useEffect(() => { localStorage.setItem("botPlaying", isPlaying.toString()); }, [isPlaying]);

  const changeTab = (tab: string) => {
    if (tab === activeTab) return;

      setOnBack(null);
      setAfterHeader(null);
      setActiveTab(tab);
      setContentState("entering");

  };

  return (
    <AppContainer>
      {!isMobile &&
      <Sidebar>
        <SidebarHeader>
          <SidebarAvatar />
          <Logo />
        </SidebarHeader>
        <SidebarNav>
          {Object.keys(tabNames).map(tab => {
            const TabIcon = tabIcons[tab];
            return (
              <SidebarItem key={tab} active={activeTab === tab} onClick={() => changeTab(tab)}>
                <Icon as={TabIcon} active={activeTab === tab} />
                {tabNames[tab]}
              </SidebarItem>
            )
          })}
        </SidebarNav>
      </Sidebar>
  }

      <Main>
        {isMobile ? <Header>
          <div style={{backgroundColor: "rgba(14, 14, 16, 1)", padding: 16, borderRadius: 16, width: "100%",
            justifyContent: "start",
            flexDirection: "row",
            gap: 8,
            margin: 0,
            alignItems: "center",
            display: "flex"
          }}>
             {(onBack) && (
          
          <BackIcon
            onClick={() => {
              onBack();        // вызываем колбэк
              setOnBack(null);  
              setAfterHeader(null);
            }}
          >
            <TbArrowBackUp  color="white" size={24} />
          </BackIcon>
        )}
        <div>
            Бот {isPlaying ? "работает" : "остановлен"}
            </div>
                      {afterHeader && <>Инвайтер {afterHeader}</>}
          </div>
        </Header> :
        
        <Header>
          <div style={{display: "flex", gap: 8, margin: 0}}>
                  {(onBack) && (
          
          <BackIcon
            onClick={() => {
              onBack();        // вызываем колбэк
              setOnBack(null);  
              setAfterHeader(null);
            }}
          >
            <TbArrowBackUp  color="white" size={32} />
          </BackIcon>
        )}
          {tabNames[activeTab]}
          {afterHeader && afterHeader}
          

       </div>
          <BotToggle>
            Бот {isPlaying ? "работает" : "остановлен"}
          </BotToggle>
        </Header>
        }

<PullToRefreshWrapper
  isMobile={isMobile}
  onRefresh={() => {
    // тут вызываем все запросы заново
    setLoading(true);
    axiosInstance.get(`/dashboard-metrics?period=${period}`).then(res => {
      setData(res.data);
      setLoading(false);
    });
    setUserLoading(true);
    axiosInstance.get(`/users?period=${period}`).then(res => {
      setUserData(res.data["users"]);
      setUserLoading(false);
    });
    setActiveTab(activeTab);
  }}
>
 
            {activeTab === "dashboard" && <DashboardPage loading={loading} data={data}><SourcesChart period={period} setPeriod={setPeriod} /></DashboardPage>}
            {activeTab === "users" && <DashboardPage loading={loading} data={data}><UsersTable loading={userLoading} data={userData} setData={setUserData} period={period} setPeriod={setPeriod} /></DashboardPage>}
            {activeTab === "payments" && <PaymentsPage />}
            {activeTab === "countries" && <CountriesPage data={countriesData} loading={countriesLoading} setData={setCountriesData} />}
            {activeTab === "inviter" && <InvitersPage inviters={inviters} setOnBack={setOnBack} setAfterHeader={setAfterHeader}></InvitersPage>}
 
        </PullToRefreshWrapper>
      </Main>
        {isMobile && (
        <MobileNav>
          <MobileNavItem active={activeTab === "dashboard"} onClick={() => changeTab("dashboard")}>
            <MobileIcon as={DashboardIcon} active={activeTab === "dashboard"} /> Главная
          </MobileNavItem>

          <MobileNavItem active={activeTab === "payments"} onClick={() => changeTab("payments")}>
            <MobileIcon as={PaymentsIcon} active={activeTab === "payments"} /> Выплаты
          </MobileNavItem>

          <MobileNavItem active={activeTab === "inviter"} onClick={() => changeTab("inviter")}>
            <MobileIcon as={InviterIcon} active={activeTab === "inviter"} /> Инвайтер
          </MobileNavItem>
        </MobileNav>
      )}
      <ToastContainer />
    </AppContainer>
  );
};

export default Dashboard;
